module.exports = __webpack_public_path__ + "img/basil_edit-outline.6370267a.svg";